import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation"; // NEU
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SIDEBAR_WIDTH = 280;
const SIDEBAR_COLLAPSED = 48;

export default function ModuleSidebar({
  modules,
  activeModuleId,
  collapsed,
  setCollapsed,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation(); // NEU
  const asideWidth = collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_WIDTH;

  const handleSelectModule = (id) => {
    navigate(`/Lessons?module=${id}`);
  };

  return (
    <aside
      className={`lesson-sidebar ${collapsed ? "collapsed" : "expanded"} d-none d-lg-block`}
      style={{
        width: asideWidth,
        flexShrink: 0,
        position: "fixed",
        top: 0,
        left: "240px",
        height: "100vh",
        borderRight: "1px solid #eee",
        background: "#fff",
        zIndex: 999,
        overflow: "hidden",
        transition: "width 280ms ease-in-out, left 280ms ease-in-out",      
      }}
    >
      <div className="d-flex align-items-center justify-content-between px-2 py-2 border-bottom">
        {!collapsed && <h5 className="m-0">{t.modules.title}</h5>} {/* ÜBERSETZT */}
        <Button
          variant="light"
          size="sm"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "Sidebar öffnen" : "Sidebar schließen"}
        >
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </Button>
      </div>

      {!collapsed && (
        <div
          className="p-2"
          style={{ height: "calc(100% - 42px)", overflowY: "auto" }}
        >
          <Card className="border-0">
            <ListGroup variant="flush">
              {modules.map((m) => {
                const isActive = activeModuleId === m.id;
                return (
                  <ListGroup.Item
                    key={m.id}
                    action
                    onClick={() => handleSelectModule(m.id)}
                    className="d-flex align-items-start justify-content-between"
                    style={{
                      borderRadius: 8,
                      marginBottom: 6,
                      backgroundColor: isActive
                        ? "rgba(30,136,229,0.08)"
                        : "transparent",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <div className="flex-grow-1 pe-2" style={{ minWidth: 0 }}>
                      <div className="fw-semibold module-list-title">
                        {m.title} {/* Kommt von Backend in richtiger Sprache */}
                      </div>
                      <small className="text-muted">
                        {m.year_level}. {t.modules.class} • {t.modules.semester} {m.semester}
                      </small>
                    </div>
                    {typeof m.order_index === "number" && (
                      <Badge bg="light" text="dark" className="flex-shrink-0">
                        {m.order_index}
                      </Badge>
                    )}
                  </ListGroup.Item>
                );
              })}

              {modules.length === 0 && (
                <div className="text-muted small px-2 py-3">
                  {t.modules.noModules} {/* ÜBERSETZT */}
                </div>
              )}
            </ListGroup>
          </Card>
        </div>
      )}
    </aside>
  );
}
